import type { ChipOption } from '@/components/ui/ChipGroup'

// The 16 genres offered in the UI (Turkish labels, mapped to source in backend).
export const GENRES: string[] = [
  'Aksiyon', 'Korku', 'Komedi', 'Dram', 'Gerilim', 'Bilim Kurgu',
  'Fantastik', 'Suç', 'Gizem', 'Romantik', 'Macera', 'Animasyon',
  'Savaş', 'Polisiye', 'Belgesel', 'Aile',
]

export const CONTENT_TYPE_OPTIONS: ChipOption[] = [
  { value: 'movie', label: '🎬 Film' },
  { value: 'series', label: '📺 Dizi' },
  { value: 'all', label: 'Hepsi' },
]

export const SORT_OPTIONS: ChipOption[] = [
  { value: 'popular', label: '🔥 Popüler' },
  { value: 'rating', label: '⭐ En yüksek puan' },
  { value: 'rating_asc', label: '📉 En düşük puan' },
  { value: 'newest', label: '🆕 En yeni' },
  { value: 'oldest', label: '📅 En eski' },
]

export const RATING_OPTIONS: ChipOption[] = [
  { value: '0', label: 'Hepsi' },
  { value: '9', label: '9+' },
  { value: '8', label: '8+' },
  { value: '7', label: '7+' },
  { value: '6', label: '6+' },
]

export const YEAR_OPTIONS: ChipOption[] = [
  { value: '0', label: 'Farketmez' },
  { value: '2020', label: '2020+' },
  { value: '2010', label: '2010+' },
  { value: '2000', label: '2000+' },
  { value: '1990', label: '1990+' },
]

// ---- "Bana Bir Şey Bul" wizard options ----
export const WIZARD_TYPE_OPTIONS: ChipOption[] = [
  { value: 'movie', label: '🎬 Film' },
  { value: 'series', label: '📺 Dizi' },
  { value: 'farketmez', label: '🎲 Farketmez' },
]

export const WIZARD_GENRE_OPTIONS: ChipOption[] = [
  ...GENRES.map((g) => ({ value: g, label: g })),
  { value: 'Farketmez', label: 'Farketmez' },
]

export const MOOD_OPTIONS: ChipOption[] = [
  { value: 'eglence', label: '😂 Eğlenmek istiyorum' },
  { value: 'gerilim', label: '😱 Gerilmek istiyorum' },
  { value: 'aksiyon', label: '🔥 Aksiyon istiyorum' },
  { value: 'beyin', label: '🧠 Beynimi yakacak bir şey' },
  { value: 'duygusal', label: '❤️ Duygusal bir şey' },
  { value: 'rahat', label: '😌 Kafamı yormak istemiyorum' },
  { value: 'gizem', label: '👀 Gizemli bir şey' },
  { value: 'korku', label: '👻 Korkmak istiyorum' },
  { value: 'farkli', label: '🚀 Farklı dünyalara dalmak' },
]

export const MOVIE_DURATION_OPTIONS: ChipOption[] = [
  { value: 'kisa', label: '90 dakikadan kısa' },
  { value: 'orta', label: '90-120 dakika' },
  { value: 'uzun', label: '120+ dakika' },
  { value: 'farketmez', label: 'Farketmez' },
]

export const SERIES_DURATION_OPTIONS: ChipOption[] = [
  { value: 'mini', label: 'Mini dizi' },
  { value: 'kisa', label: 'Kısa bölümler' },
  { value: 'normal', label: 'Normal' },
  { value: 'uzun', label: 'Uzun soluklu' },
  { value: 'farketmez', label: 'Farketmez' },
]

export const ERA_OPTIONS: ChipOption[] = [
  { value: 'son', label: 'Son yıllardan' },
  { value: '2000', label: "2000'ler" },
  { value: '90', label: "90'lar ve öncesi" },
  { value: 'farketmez', label: 'Farketmez' },
]
